var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRupee(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m418.474 0h-162.474l-20 35 20 42.264c20.028 11.445 35.606 29.825 43.418 51.856h-43.418l-20 32.28 20 32.28h43.418c-7.812 22.03-23.39 40.41-43.418 51.856l-20 39.464 20 30.539c55.651-17.324 98.483-64.013 110.272-121.86h52.203v-64.559h-52.203c-4.858-23.839-14.99-45.783-29.116-64.559h81.319v-64.561z",
    fill: "#ffc34d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m282.729 512 45.65-45.651-72.379-72.378-20 32.029 20 59.271z",
    fill: "#ffc34d"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#ffe14d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m208.118 258.238h-114.592v64.559l162.474 162.474v-91.301l-71.174-71.174h23.292c16.666 0 32.746-2.547 47.882-7.258v-70.005c-14.131 8.076-30.473 12.705-47.882 12.705z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m93.526 129.119h162.474v64.559h-162.474z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m208.118 0h-114.592v64.559h114.593c17.409 0 33.751 4.629 47.882 12.704v-77.263z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRupee);
export default __webpack_public_path__ + "static/media/rupee.ee9fbd2c373aa5c0c9225ba51cf32c8f.svg";
export { ForwardRef as ReactComponent };